<script setup lang="ts">
import type { FilterButtonClickedPageType as PageType } from "~/analytics/segment";

const { filtersCount, pageType } = defineProps<{
  filtersCount?: number | undefined;
  pageType?: PageType;
}>();

const sheetMenuIsOpen = defineModel<boolean>("isOpen", {
  default: false,
});

const closeFilterMenu = () => {
  sheetMenuIsOpen.value = false;
};
</script>

<template>
  <div>
    <BaseFilterButton
      data-test="product-filter-button"
      :filter-count="filtersCount"
      :page-type="pageType"
      :show-text="true"
      @open-filter-menu="sheetMenuIsOpen = true"
    />
    <BaseSheetMenu
      :is-open="sheetMenuIsOpen"
      display-side="right"
      @close="closeFilterMenu"
    >
      <BaseMenuWithHeader
        :title="$t('filter.title')"
        :hide-back-button="true"
        data-test="product-filter-section"
        @close-menu="closeFilterMenu"
      >
        <slot />
        <template #actions>
          <slot
            name="actions"
            :close-filter-menu="closeFilterMenu"
          />
        </template>
      </BaseMenuWithHeader>
    </BaseSheetMenu>
  </div>
</template>
